/**
 * Позиция отображения уведомлений
 */
export enum NotyPosition {
    bottomCenter = 'bottom-center',
    topRight = 'top-right',
}
